import React from 'react';
import { X } from 'lucide-react';
import { GENDERS, WORKER_TYPES, COLLARS, PAY_TYPES, ROLL_STATUSES } from '@/services/staffMasterApi';

export const STAFF_FILTER_DEFAULT = {
  section: 'all', designation: 'all', gender: 'all', worker_type: 'all', agency: 'all', collar: 'all', pay_type: 'all', roll_status: 'all',
};
// [field, label, "all" text, fixed choices | null (from Staff Master values), allow "Not set"]
export const STAFF_FILTER_FIELDS = [
  ['section', 'Staff section', 'All sections', null, true],
  ['designation', 'Designation', 'All designations', null, true],
  ['gender', 'Gender', 'Male + Female', GENDERS, true],
  ['worker_type', 'Regular / Contract', 'Regular + Contract', WORKER_TYPES, true],
  ['agency', 'Agency', 'All agencies', null, true],
  ['collar', 'Collar', 'White + Blue', COLLARS, true],
  ['pay_type', 'Pay type', 'All pay types', [...PAY_TYPES, { value: 'contract', label: 'Contract' }], true],
  ['roll_status', 'In Roll / Left', 'In Roll + Left', ROLL_STATUSES, false],
];

export const staffFilterLabel = (field, value, noBase) => {
  const def = STAFF_FILTER_FIELDS.find(([f]) => f === field);
  if (value === noBase) return `${def[1]} not set`;
  return def[3]?.find((o) => o.value === value)?.label || value;
};

const selCls = 'border border-gray-300 rounded-lg px-2.5 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none max-w-[190px]';

export const StaffFilters = ({ value, onChange, options = {}, noBase = '__none__' }) => {
  const active = Object.values(value).filter((v) => v !== 'all').length;
  return (
    <div className="border-t border-gray-100 pt-3" data-testid="rank-staff-filters">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-xs font-semibold text-gray-500">Staff filters (Staff Master)</span>
        {active > 0 && (
          <>
            <span className="text-[11px] font-semibold rounded-full bg-indigo-100 text-indigo-700 px-2 py-0.5" data-testid="rank-staff-filter-count">{active} on · ranked among themselves</span>
            <button type="button" onClick={() => onChange(STAFF_FILTER_DEFAULT)} className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-rose-600 transition-colors" data-testid="rank-staff-filter-clear">
              <X className="w-3 h-3" /> Clear
            </button>
          </>
        )}
      </div>
      <div className="flex flex-wrap items-end gap-3">
        {STAFF_FILTER_FIELDS.map(([field, label, all, fixed, notSet]) => {
          const choices = fixed || (options[field] || []).map((v) => ({ value: v, label: v }));
          return (
            <div key={field}>
              <label className="block text-[11px] text-gray-500 mb-1">{label}</label>
              <select value={value[field]} onChange={(e) => onChange({ ...value, [field]: e.target.value })}
                className={`${selCls} ${value[field] !== 'all' ? 'border-indigo-400 bg-indigo-50' : ''}`} data-testid={`rank-filter-${field}`}>
                <option value="all">{all}</option>
                {choices.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                {notSet && <option value={noBase}>Not set</option>}
              </select>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StaffFilters;
